/**
 * Reference:
 *   https://github.com/iZettle/authorization/blob/master/core/src/main/java/com/izettle/authorization/dto/UserType.java
 */
let UserType;
/**
 * References:
 *   https://github.com/iZettle/authorization/blob/master/core/src/main/java/com/izettle/authorization/dto/Permission.java
 *   https://github.com/iZettle/authorization/blob/master/core/src/main/java/com/izettle/authorization/dto/ElevatedPermission.java
 */

(function (UserType) {
  UserType["USER"] = "USER";
  UserType["SYSTEM"] = "SYSTEM";
})(UserType || (UserType = {}));

let Scope;
/**
 * Created in admin
 */

(function (Scope) {
  Scope["READ_CUSTOMER"] = "READ:CUSTOMER";
  Scope["WRITE_CUSTOMER"] = "WRITE:CUSTOMER";
  Scope["READ_FINANCE"] = "READ:FINANCE";
  Scope["WRITE_FINANCE"] = "WRITE:FINANCE";
  Scope["READ_PURCHASE"] = "READ:PURCHASE";
  Scope["WRITE_PURCHASE"] = "WRITE:PURCHASE";
  Scope["READ_PRODUCT"] = "READ:PRODUCT";
  Scope["WRITE_PRODUCT"] = "WRITE:PRODUCT";
  Scope["READ_USERINFO"] = "READ:USERINFO";
  Scope["WRITE_USERINFO"] = "WRITE:USERINFO";
  Scope["READ_ONLINEPAYMENT"] = "READ:ONLINEPAYMENT";
  Scope["WRITE_ONLINEPAYMENT"] = "WRITE:ONLINEPAYMENT";
  Scope["ALL_INTERNAL"] = "ALL:INTERNAL";
  Scope["SYSTEM_ALL"] = "ALL:SYSTEM";
  Scope["WRITE_REFUND"] = "WRITE:REFUND";
  Scope["WRITE_REFUND2"] = "WRITE:REFUND2";
  Scope["WRITE_EMONEY"] = "WRITE:EMONEY";
  Scope["WRITE_CAPITAL"] = "WRITE:CAPITAL";
  Scope["WRITE_BANK_ACCOUNT"] = "WRITE:BANK_ACCOUNT";
})(Scope || (Scope = {}));

let AdminAccess;
/**
 * Reference:
 *   https://github.com/iZettle/admin-two/blob/master/src/authentication/stores/permissions.ts#L11-L15
 */

(function (AdminAccess) {
  AdminAccess["KEYVAL"] = "KEYVAL";
})(AdminAccess || (AdminAccess = {}));

let AdminAccessLevel;

(function (AdminAccessLevel) {
  AdminAccessLevel["NONE"] = "NONE";
  AdminAccessLevel["READ"] = "READ";
  AdminAccessLevel["READ_AND_WRITE"] = "READ_AND_WRITE";
})(AdminAccessLevel || (AdminAccessLevel = {}));

export { AdminAccess, AdminAccessLevel, Scope, UserType };
//# sourceMappingURL=auth.js.map
